import { useQuery } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { getApplicationAssignments } from '../../requests/getApplicationAssignments';

export const useApplicationAssignments = (
  uuid: string,
  definitionName: string,
  options?: {
    enabled?: boolean;
    refetchOnWindowFocus?: boolean;
    refetchOnMount?: boolean;
    refetchOnReconnect?: boolean;
  },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getApplicationAssignments>>
  >({
    queryKey: [APPLICATION_BASE_PATH, uuid, 'assignments'],
    queryFn: () =>
      getApplicationAssignments(constructGet, uuid, definitionName),
    enabled: Boolean(uuid) && (options?.enabled ?? true),
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
    refetchOnMount: options?.refetchOnMount ?? false,
    refetchOnReconnect: options?.refetchOnReconnect ?? false,
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'assignments'),
    ...rest,
  };
};
